module.exports = __webpack_public_path__ + "static/media/statistics.4b336133.svg";